import React from 'react';

export interface DialogTitleProps extends React.HTMLAttributes<HTMLDivElement> {}

export const DialogTitleBase: React.FunctionComponent<DialogTitleProps> = props => (
    <div {...props} />
);
